import React from "react";
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { TiltCard } from "../common/TiltCard";
import { usePublicGlassSurface } from "../common/publicVisual";

/** 404 with the same ambient + glass tilt as other public routes (uses Layout header/footer). */
const NotFound = () => {
  const glass = usePublicGlassSurface();
  const muted = useColorModeValue("gray.600", "gray.400");
  const numeral = useColorModeValue("teal.600", "teal.300");

  return (
    <Box
      as="main"
      minH="65vh"
      py={{ base: 14, md: 20 }}
      bg="transparent"
      display="flex"
      alignItems="center"
    >
      <Container maxW="md" px={{ base: 4, md: 6 }}>
        <TiltCard
          tilt={11}
          borderRadius="2xl"
          borderWidth="1px"
          p={{ base: 8, md: 10 }}
          textAlign="center"
          sx={{ transformStyle: "preserve-3d" }}
          {...glass}
        >
          <VStack spacing={6}>
            <Heading
              as="h1"
              size="4xl"
              fontWeight="extrabold"
              letterSpacing="-0.06em"
              lineHeight={0.9}
              color={numeral}
              sx={{
                textShadow:
                  "0 1px 0 rgba(255,255,255,0.4), 0 3px 0 rgba(45,212,191,0.25), 0 18px 40px rgba(15,118,110,0.35)",
              }}
            >
              404
            </Heading>
            <Text fontSize="lg" color={muted} lineHeight="tall">
              We couldn&apos;t find that page. The homepage and dashboard are still here.
            </Text>
            <Button as={RouterLink} to="/" colorScheme="teal" size="lg" fontWeight="bold">
              Back to homepage
            </Button>
          </VStack>
        </TiltCard>
      </Container>
    </Box>
  );
};

export default NotFound;
